import type { ReactNode } from 'react';
import { BrandMark } from '../shell/BrandMark.js';

/**
 * The frame for every signed-out page (sign in, sign up, invitation, reset, verify): the brand, a
 * title, the form card and a footer line.
 */
export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-bg px-4 py-10">
      <div className="w-full max-w-md">
        <div className="mb-6 flex justify-center">
          <BrandMark />
        </div>
        <div className="rounded-2xl border border-card-border bg-card-background p-6 shadow-xs sm:p-8">
          <header className="mb-6 text-center">
            <h1 className="text-2xl font-semibold text-text-primary">{title}</h1>
            {subtitle && <p className="mt-1.5 text-sm text-text-tertiary">{subtitle}</p>}
          </header>
          {children}
        </div>
        {footer && <p className="mt-6 text-center text-sm text-text-tertiary">{footer}</p>}
      </div>
    </main>
  );
}
